export const USER_GUIDE_URL = 'https://www.cryptoblk.io/demo/MIDAS/Midas_User_Guide_v1.1_20180813.pdf';


// WEBPACK FOOTER //
// ./src/Config/userGuideConfig.ts